var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysDoubleChevronLeft = function SvgSysDoubleChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 8.072a.517.517 0 0 1 .144-.354l4-4.067a.5.5 0 0 1 .82.535.501.501 0 0 1-.107.163l-3.65 3.713 3.646 3.583a.502.502 0 0 1 .021.72.502.502 0 0 1-.722-.007l-4-3.932a.491.491 0 0 1-.148-.349L3.5 8.072Zm4 0a.52.52 0 0 1 .146-.354l4-4.067a.494.494 0 0 1 .553-.13.501.501 0 0 1 .16.83L8.71 8.064l3.646 3.583a.499.499 0 0 1-.007.693.5.5 0 0 1-.694.02l-4-3.932a.528.528 0 0 1-.148-.349L7.5 8.072Z"
  })));
};
export default SvgSysDoubleChevronLeft;